export const Logo = ({
    size = "md",
    showWordmark = false,
    invert = false,
    testid = "site-logo",
}) => {
    // Wider aspect ratio since new logo includes wordmark
    const sizes = {
        sm: "h-10",
        md: "h-14",
        lg: "h-20",
    };
    const cls = sizes[size] || sizes.md;
    return (
        <span
            data-testid={testid}
            className="inline-flex items-center"
        >
            <img
                src="/monogram.png"
                alt="Treasure Valley Turf & Greens"
                className={`${cls} w-auto ${invert ? "brightness-0 invert" : ""}`}
                draggable="false"
            />
        </span>
    );
};
